import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";

Vue.config.productionTip = false;

import Buefy from "buefy";
import "./scss/buefy.scss";
Vue.use(Buefy);

// Jodit Editor components
import JoditVue from "jodit-vue";
Vue.use(JoditVue);

require("./plugins/plugins");
require("./filters");
require("./functions");

new Vue({
    router,
    store: store,
    render: h => h(App)
}).$mount("#app");
